import { render, staticRenderFns } from "./SliderVideo.vue?vue&type=template&id=3ccf6b95&scoped=true"
import script from "./SliderVideo.vue?vue&type=script&lang=js"
export * from "./SliderVideo.vue?vue&type=script&lang=js"
import style0 from "./SliderVideo.vue?vue&type=style&index=0&id=3ccf6b95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf6b95",
  null
  
)

export default component.exports